
import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const productsBaseUrl = `${apiUrl}/products`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const productApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${productsBaseUrl}?${query}`);
  },
  save: product => {
    return Axios.post(productsBaseUrl, product, config);
  },
  delete: id => {
    return Axios.delete(`${productsBaseUrl}/${id}`, config);
  },

};
